import { Box, styled } from "@mui/material";

export const TermsHtmlContainer = ({ html }: { html?: string }) => {
  const parsedHtml = parseTermsHtml(html ?? "");

  return <StyledBox dangerouslySetInnerHTML={{ __html: parsedHtml }} />;
};

const StyledBox = styled(Box)(({ theme }) => ({
  a: {
    color: theme.palette.teal.dark,
    textDecoration: "none",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

const parseTermsHtml = (html: string) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  doc.querySelectorAll("a").forEach((link) => {
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");
  });

  return doc.body.innerHTML;
};
